// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"styledTextArea_ErrorMessage__ffxox","InvalidInput":"styledTextArea_InvalidInput__fDBxC","NoResize":"styledTextArea_NoResize__0rO6R"};